import classNames from 'classnames'
import BaseInput, { BaseInputProps } from './BaseInput'
import LabelControl from './LabelControl'
import { ZodIssue } from 'zod'
import useZodErrorParse from 'hooks/useZodErrorParse'
import InlineErrorWrapper from './InlineErrorWrapper'

interface InputFieldProps extends BaseInputProps {
  labelKey?: string,
  className?: string,
  errors: ZodIssue[]
}

const InputField = (props: InputFieldProps) => {
  const { fieldId, labelKey, className, errors = [] } = props
  const { isError, errorCode } = useZodErrorParse(errors, fieldId)

  return (
    <div className={classNames("input-container mb-3 position-relative", className, { "error": isError })}>
      <LabelControl fieldId={fieldId} labelKey={labelKey} />
      <BaseInput {...props} />
      <InlineErrorWrapper errorCode={errorCode}/>
    </div>
  )
}

export default InputField